module.exports = __webpack_public_path__ + "static/media/saas-agreement-v1.b9cad04b.md";